require('./modifyLimitSuccessStep.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { useEffect } = React;
// @ commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
//@utilities
const { formatText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const { getFormattedString } = require('utilities/currencyHelper');
const { formatCardNumber } = require('utilities/cardsHelper');
const { recordLinkV2 } = require('utilities/tagging');
//@constants
const { CARD_MODIFY_LIMIT_PENDING_MESSAGE, FIRST_STEP,EURO_TEXT } = require('constants/index');
 
const ModifyLimitSuccessStep = props => {
    const { immCard, immCardModifyLimit, url, buttonText,immHireCreditLimit, getCustomTags, pageName } = props;

    const immFirstStep = immCardModifyLimit.getIn(['steps', FIRST_STEP]);
    const operationStatus = immCardModifyLimit.get('operationStatus');
    const cardAlias = toCamelCase(immCard.getIn(['alias', 'current']));
    const cardNumber = formatCardNumber(immCard.get('number'), 4, '*')
    const creditLimit = immHireCreditLimit.get('creditLimit');
    const typeCode = immCard.getIn(['product', 'type']);
    const subtypeCode = immCard.getIn(['product', 'subtype']);

     const newLimit = {
        amount: creditLimit,
        currency: EURO_TEXT
    };
    let title;
    let message;
    let formattedAmount;

    useEffect(() => {
        if (getCustomTags) {
            const productType = `${typeCode}.${subtypeCode}`;
            const tag = getCustomTags({ pageName, creditLimit, productType }).onProcessSuccess;
            recordLinkV2(tag);
        }
    }, []);

    if (operationStatus === CARD_MODIFY_LIMIT_PENDING_MESSAGE) {
         const tentativeAmount = {
            amount: immFirstStep.get('tentativeLimit'),
            currency: immFirstStep.get('currency')
        };

        formattedAmount = getFormattedString(tentativeAmount);
        message = formatText('cardModifyLimitSuccessStep-pendingMessage', [formattedAmount]);

        if (immCard.get('isViaT')) {
            title = formatText('cardModifyLimitSuccessStep-pendingTitleViaT');
        } else {
            title = formatText('cardModifyLimitSuccessStep-pendingTitle', [cardAlias, cardNumber]);
        }
    } else {
        const approvedAmount = {
            amount: immCardModifyLimit.get('approvedAmount'),
            currency: immFirstStep.get('currency')
        };
        
        formattedAmount = getFormattedString({
            amount: newLimit.amount,
            currency: newLimit.currency,
            decimalsLength: 0
        })
        message = formatText('cardModifyLimitSuccessStep-approvedMessage', [formattedAmount]);

        if (immCard.get('isViaT')) {
            title = formatText('cardModifyLimitSuccessStep-approvedTitleViaT');
        } else {
            title = formatText('cardModifyLimitSuccessStep-approvedTitle', [cardAlias, cardNumber]);
        }
    }

    const goBackButton = {
        label: buttonText || formatText('cards-backToCard', [cardAlias]).toUpperCase(),
        url: url
    };

    const handleClickMainButton = () => {
        if (getCustomTags) {
            const tag = getCustomTags().onClickButtonSuccessScreen;
            recordLinkV2(tag);
        }
    };

    return (
        <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
            <WizardSuccess
                successMessage={title}
                mainButton={goBackButton}
                onMainButtonClick={handleClickMainButton}
                >
                <section className="row no-gutter">
                    <div className="col-xs-6 col-md-7">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-6 col-md-5">
                        {message}
                    </div>
                </section>
            </WizardSuccess>
        </div>
    );
};

ModifyLimitSuccessStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardModifyLimit: PropTypes.object.isRequired,
    url: PropTypes.string,
    buttonText: PropTypes.string
};

module.exports = ModifyLimitSuccessStep;
